import React from 'react';
import { Link } from 'react-router-dom';

// 멤버 카드 컴포넌트 - 멤버 정보를 보여주는 재사용 가능한 컴포넌트
function MemberCard({ name, email, photo, researchInterest, github, isAdmin, memberId }) {
  return (
    <div className="member-card">
      {/* 사진 */}
      <div className="member-photo">
        <img src={photo} alt={name} />
      </div>

      {/* 정보 */}
      <div className="member-info">
        <h3><b>{name}</b></h3>
        <p><b>E-mail</b>: {email}</p>
        <p><b>Research Interest</b>: {researchInterest}</p>
        {github && (
          <p>
            <a href={github} target="_blank" rel="noopener noreferrer">
              Github
            </a>
          </p>
        )}
        
        {/* Edit 버튼 - 관리자에게만 표시 */}
        {isAdmin && (
          <div style={{ marginTop: '10px' }}>
            <Link 
              to={`/edit-member/${memberId}`}
              style={{
                display: 'inline-block',
                padding: '4px 12px',
                fontSize: '12px',
                backgroundColor: '#0066cc',
                color: '#fff',
                textDecoration: 'none',
                borderRadius: '3px'
              }}
            >
              Edit
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default MemberCard;
